// extracted by mini-css-extract-plugin
module.exports = {"popover":"ConfirmAction_popover__3-89-","wide":"ConfirmAction_wide__58Dd4","error":"ConfirmAction_error__3zM7j"};